import React from "react";
import { TailSpin } from "react-loader-spinner";
import "./index.scss"; // Optional, for custom styling

const Loader = ({ className, height, width, color }) => {
  return (
    <div className={`loader-container ${className}`}>
      <TailSpin
        visible={true}
        height={height ? height : "50"}
        width={width ? width : "50"}
        color={color ? color : "#405189"}
        ariaLabel="tail-spin-loading"
        radius="1"
      />
    </div>
  );
};

export default Loader;
